import {styled} from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';

export const DropIcon = styled(RemoveIcon)(({theme}) => ({
    background: theme.palette.error.dark,
    borderRadius: '50%',
    color: '#fff',
}));
